<template>
  <div v-if="hydrated" :class="[$style.container, hostClass]">
    <activity-summary-section :section="activitySummarySection">
      <secondary-actions></secondary-actions>
    </activity-summary-section>

    <custom-section
      v-if="hasFollowUpSection"
      :section="followUpSection"
    ></custom-section>

    <section>
      <submit-button
        @success="handleSuccess"
        :loggingToCrm="loggingToCrm"
      ></submit-button>
    </section>

    <dialogs-wrapper name="activity-summary"></dialogs-wrapper>
  </div>
</template>

<script>
import axios from "axios";
import { createNamespacedHelpers } from "vuex";
import ActivitySummarySection from "./activity-summary-section/activity-summary-section";
import CustomSection from "./custom-section/custom-section";
import SubmitButton from "./submit-button/submit-button";
import SecondaryActions from "./secondary-actions/secondary-actions";
import * as Sentry from "@sentry/browser";
import {
  successNotification,
  layoutsNotConfiguredNotification,
} from "./notifications";

const { mapState, mapGetters, mapMutations } =
  createNamespacedHelpers("activitySummary");

export default {
  components: {
    ActivitySummarySection,
    CustomSection,
    SubmitButton,
    SecondaryActions,
  },
  data() {
    return {
      sections: [],
      team: this.$_activitySummary_config.getTeam(),
      user: this.$_activitySummary_config.getUser(),
    };
  },
  computed: {
    ...mapGetters(["hasActivity"]),
    ...mapState(["activity", "selectedProspect"]),
    crmName() {
      return this.team.crm.name;
    },
    hostClass() {
      return `host-${this.$_activitySummary_config.hostApp}`;
    },
    hydrated() {
      return this.sections.length > 0;
    },
    activitySummarySection() {
      return this.sections.find(
        (section) => section.label === "activity-summary"
      );
    },
    followUpSection() {
      return this.sections.find((section) => section.label === "follow-up");
    },
    isMeetingEnded() {
      return ["completed", "busy", "no-answer", "failed"].includes(
        this.activity.status
      );
    },
    hasFollowUpSection() {
      const isInternal = this.activity.isInternal;
      const followUpSectionExists = !!this.followUpSection;
      const isSoftphone =
        this.activity.type === "softphone" ||
        this.activity.type === "softphone-inbound";
      const isEndedConference =
        this.activity.type === "conference" && this.isMeetingEnded;

      const hasFollowUpSection =
        followUpSectionExists &&
        !isInternal &&
        (isSoftphone || isEndedConference);

      return hasFollowUpSection;
    },
    loggingToCrm() {
      return this.hasFollowUpSection && this.user.crmRequired;
    },
  },
  created() {
    if (!this.hasActivity) {
      Sentry.withScope((scope) => {
        scope.setExtra("debug", false);
        Sentry.captureMessage("Unknown activity");
      });

      return;
    }

    this.resetActivitySummary();
    this.retrieveFields();
  },
  methods: {
    ...mapMutations(["setLayoutId", "resetActivitySummary"]),
    retrieveFields() {
      axios
        .get(
          `${this.$_activitySummary_config.jiminnyHost()}/api/v1/crm/layouts`,
          {
            params: {
              type: `${this.activity.type}-summary`,
            },
          }
        )
        .then((response) => {
          this.sections = response.data.entities;
          this.setLayoutId(response.data.id);
        })
        .catch(() => {
          layoutsNotConfiguredNotification().show();
        });
    },
    handleSuccess() {
      this.$emit("success");
      const message = this.getSuccessMessage();
      successNotification({ message }).show();
    },
    getSuccessMessage() {
      if (!this.loggingToCrm) {
        return "Your activity has been saved to Jiminny";
      }

      if (
        this.selectedProspect &&
        this.selectedProspect.hasOwnProperty("crmUrl")
      ) {
        return `Your activity has been sent to <a href="${this.selectedProspect.crmUrl}" target="_blank">${this.crmName}.</a>`;
      } else {
        return `Your activity has been sent to ${this.crmName}`;
      }
    },
  },
};
</script>

<style module lang="less" src="./activity-summary.less"></style>



// WEBPACK FOOTER //
// activity-summary.vue?439b797f